import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { baseContainer } from "../index";
import Page from "./page";

const BaseRoutes = ({ routes, documentTitle }) => {
  return <Routes>{CreateRoutes(routes, documentTitle)}</Routes>;
};

export default BaseRoutes;

const CreateRoutes = (routes, documentTitle) => {
  let permissions = baseContainer.authenticationService.permissions;
  return routes
    .filter(
      (route) =>
        !route.permissions ||
        route.permissions.some((permission) => permissions.includes(permission))
    )
    .map((route, index) =>
      route.children ? (
        <Route
          key={index + route.path}
          path={route.path}
          element={route.component}
        >
          {CreateRoutes(route.children, documentTitle)}
        </Route>
      ) : route.redirectTo ? (
        <Route
          path={route.path}
          element={<Navigate to={route.redirectTo} replace={true} />}
        />
      ) : (
        <Route
          key={index + route.path}
          path={route.path}
          element={<Page route={route} documentTitle={documentTitle} />}
        />
      )
    );
};
